import React from "react";
import "../componentsStyle.scss";
import { ContactForm } from "./ContactForm";
import { ContactInformation } from "./ContactInformation";

export const ContactSection = ({ languageId }) => {
  return (
    <section className="contact-section">
      <ContactForm languageId={languageId} />
      <ContactInformation languageId={languageId} />
    </section>
  );
};
